import { useState } from "react";
import Body from "./components/Body"


function App() {
  const [darkMode, setDarkMode] = useState(true);
  
  return (
    <div className={`w-full min-h-screen  ${darkMode && 'dark '}`} >
      
     
      <Body setDarkMode={setDarkMode} />
      
    </div>
  );
}

export default App;
